<style src="./VehiclePixBying.scss" lang="scss"></style>
<template>
  <div class="wrapper wrapper-content">
    <div class="mail-box-header">
      <form class="form-horizontal" @submit.prevent="filterReport">
        <div class="row">
          <div class="col-lg-3">
            <div class="form-group">
              <label class="col-sm-12">Placa</label>
              <div class="col-sm-12">
                <input
                  type="text"
                  class="form-control"
                  v-model="licencePlate"
                  placeholder="Ex: ABC1234"
                />
              </div>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="form-group">
              <label class="col-sm-12">ID da Transação</label>
              <div class="col-sm-12">
                <input
                  type="text"
                  class="form-control"
                  v-model="transactionId"
                  placeholder="ID da transação"
                />
              </div>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="form-group">
              <label class="col-sm-12">Data Aproximada</label>
              <div class="col-sm-12">
                <input
                  type="datetime-local"
                  class="form-control"
                  v-model="approximateDate"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-2">
            <button class="btn btn-lg btn-primary" type="submit">
              <i class="fa fa-search"></i>
              Buscar
            </button>
          </div>
        </div>
      </form>
    </div>

    <spinner v-if="showSpinner" />

    <div class="mail-box">
      <table class="table table-hover table-mail">
        <thead>
          <tr>
            <th>Status</th>
            <th>Data</th>
            <th>Placa</th>
            <th>Valor</th>
            <th>ID da Transação</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, idx) in resultList" :key="idx">
            <td>
              <span :class="statusBadgeClass(item.status)">
                {{ statusLabel(item.status) }}
              </span>
            </td>
            <td>{{ formatDate(item.createdAt) }}</td>
            <td>{{ upperCase(item.licencePlate) }}</td>
            <td>R$ {{ toCurrencyBR(item.amount) }}</td>
            <td>{{ item.transactionId }}</td>
          </tr>
          <tr v-if="!showSpinner && resultList.length === 0">
            <td colspan="5" class="text-center">Nenhum resultado encontrado.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import Spinner from '@/components/Spinner';

export default {
  components: { Spinner },
  data() {
    return {
      showSpinner: false,
      licencePlate: '',
      transactionId: '',
      approximateDate: this.nowString(),
      resultList: [],
    };
  },
  methods: {
    statusBadgeClass(status) {
      const map = {
        paid: 'label label-success',
        pending: 'label label-warning',
      };
      return map[status] || 'label label-default';
    },
    statusLabel(status) {
      const map = {
        paid: 'Pago',
        pending: 'Pendente',
      };
      return map[status] || status;
    },
    upperCase(value) {
      if (!value) return '-';
      return value.toUpperCase();
    },
    nowString() {
      const dt = new Date();
      dt.setSeconds(0, 0);
      const pad = n => ('0' + n).slice(-2);
      return `${dt.getFullYear()}-${pad(dt.getMonth() + 1)}-${pad(dt.getDate())}T${pad(dt.getHours())}:${pad(dt.getMinutes())}`;
    },
    toCurrencyBR(value) {
      if (!value && value !== 0) return '-';
      return (value / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
    },
    formatDate(value) {
      if (!value) return '-';
      return new Date(value).toLocaleString('pt-BR');
    },
    async filterReport() {
      if (!this.transactionId && !this.approximateDate) {
        alert('Informe o ID da Transação ou a Data Aproximada.');
        return;
      }

      this.showSpinner = true;
      this.resultList = [];

      const params = {};
      if (this.transactionId) {
        params.transactionId = this.transactionId;
      } else {
        const center = new Date(this.approximateDate);
        params.startDate = new Date(center.getTime() - 10 * 60 * 1000).toISOString();
        params.endDate = new Date(center.getTime() + 10 * 60 * 1000).toISOString();
      }
      if (this.licencePlate) {
        params.licencePlate = this.licencePlate.toUpperCase();
      }

      try {
        const result = await this.$store.dispatch('FINANCIAL-ACCOUNT/GetVehiclePixTransactions', params);
        this.resultList = result.transactions || [];
      } catch {
        this.resultList = [];
      } finally {
        this.showSpinner = false;
      }
    },
  },
};
</script>
